import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "thumbnail" }
const _hoisted_2 = { class: "position-relative text-center i-95" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "placeholder-mask neon-rounded",
  style: {"font-size":"2em"}
}
const _hoisted_5 = {
  key: 1,
  class: "bg-light placeholder-mask neon-rounded",
  style: {"font-size":"2em"}
}
const _hoisted_6 = {
  key: 4,
  class: "spinner-mask",
  style: {"font-size":"2em"}
}
const _hoisted_7 = ["accept"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_icon = _resolveComponent("vue-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.url)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ($options.isImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: $props.url,
                  class: "neon-rounded",
                  style: {width:'100%','height':'100%','object-fit':'cover','object-position':'center'}
                }, null, 8 /* PROPS */, _hoisted_3))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_vue_icon, { name: "thumbnailAssetUploadedFile" })
                ]))
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (!$data.isProcessing)
              ? (_openBlock(), _createBlock(_component_vue_icon, {
                  key: 0,
                  name: "thumbnailAssetAdd"
                }))
              : _createCommentVNode("v-if", true)
          ])),
      ($props.url)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            href: "javascript:",
            class: "thumbnail-mask",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.insertImage && $options.insertImage(...args)))
          }))
        : _createCommentVNode("v-if", true),
      ($props.url)
        ? (_openBlock(), _createElementBlock("a", {
            key: 3,
            href: "javascript:",
            class: "btn btn-sm btn-danger delete",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.deleteImage && $options.deleteImage(...args))),
            title: "Usuń"
          }, [
            _createVNode(_component_vue_icon, { name: "thumbnailAssetRemove" })
          ]))
        : _createCommentVNode("v-if", true),
      ($data.isProcessing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_vue_icon, {
              name: "thumbnailAssetUploading",
              spin: ""
            })
          ]))
        : _createCommentVNode("v-if", true),
      _withDirectives(_createElementVNode("input", {
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.upload && $options.upload(...args))),
        accept: $options.accept,
        class: "thumbnail-mask",
        type: "file",
        ref: "input"
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7), [
        [_vShow, !$props.url && !$data.isProcessing]
      ])
    ])
  ]))
}